import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { TransitOperationFormValues } from 'features/declaration/models/schemas/transitOperationFormSchema'
import useCodelist from 'features/declaration/codelist/api/useCodelist'
import FormCollapsibleColumn from 'components/p5/FormCollapsibleColumn'
import FormField from 'components/p5/FormField'
import FormSelect from 'components/p5/FormSelect'
import { CodelistResponse } from 'api/models'
import useDeclarationFieldRequirements
  from 'features/declaration/form/components/useDeclarationFieldRequirements'

interface TransportSectionProps {
  isEnsMode: boolean
}

function TransportSection({ isEnsMode }: Readonly<TransportSectionProps>) {
  const { t } = useTranslation()

  const transportModeFilterFn = useCallback(() => (item: CodelistResponse): boolean => {
    if (!isEnsMode) {
      return true
    }
    return item.code?.startsWith('TRANSPORT_MODE_3') ?? false
  }, [isEnsMode])
  const [, transportModeOptions] = useCodelist('TRANSPORT_MODES', transportModeFilterFn)

  const departureTransportMeans = transportModeOptions.filter((item) => !item.value.endsWith(9)) // B1091

  const fieldRequirements = useDeclarationFieldRequirements<TransitOperationFormValues>(
    'transitOperation',
    [
      'inlandModeOfTransport',
      'borderModeOfTransport',
    ],
  )

  return (
    <section className="py-3">
      <FormCollapsibleColumn
        columnId="declaration-transport"
        headingLabel={t('declaration.p5.transport')}
      >
        {
          !isEnsMode ? (
            <FormField labelKey="declaration.p5.inlandTransportMode">
              <FormSelect
                <TransitOperationFormValues>
                field="inlandModeOfTransport"
                labelKey="declaration.p5.inlandTransportMode"
                options={departureTransportMeans}
                type="sync"
                fieldRule={fieldRequirements.inlandModeOfTransport}
              />
            </FormField>
          ) : null
        }
        <FormField labelKey="declaration.p5.borderTransportMode" fieldRule={fieldRequirements.borderModeOfTransport}>
          <FormSelect
            <TransitOperationFormValues>
            field="borderModeOfTransport"
            labelKey="declaration.p5.borderTransportMode"
            options={transportModeOptions}
            type="sync"
            fieldRule={fieldRequirements.borderModeOfTransport}
          />
        </FormField>
      </FormCollapsibleColumn>
    </section>
  )
}

export default TransportSection
